<template>
  <div v-if="selectedMapData" class="resource-map-dialog col-block width-full">
    <div class="resource-map-data-container col-block width-full">
      <resourceMapData
        :key="selectedMapData.id"
        :data="selectedMapData"
        :active="true"
        :selectable="false"
      ></resourceMapData>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="resoure-map-map-container" :style="{ height: (windowHeight / 2) + 'px' }">
      <googleMap
        :position="{ lat: selectedMapData.latitude - 0, lng: selectedMapData.longitude - 0 }"
        :mapOption="{
          zoom: 10,
          zoomControl: false,
          streetViewControl: false,
          scaleControl: false,
          rotateControl: false,
          panControl: false,
          mapTypeControl: false,
          fullscreenControl: false
        }"
        :markerOptions="markerOptions"
        @markerEvent="(event, marker, map) => markerEvent(event, marker, map)"
      ></googleMap>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="resource-map-button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="main-button2 circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___back') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import resourceMapData from '../resourceMap/data.vue'
import googleMap from '../tool/googleMap.vue'
import responsitive from '../../mixins/responsitive.vue'

export default {
  components: {
    resourceMapData,
    googleMap
  },
  mixins: [
    responsitive
  ],
  props: {
    param: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selectedMapData: this.param.selectedMapData
    }
  },
  computed: {
    markerOptions () {
      return this.resoucreMapDatas.map(data => ({
        position: { lat: data.latitude - 0, lng: data.longitude - 0 },
        icon: (data.id === this.selectedMapData.id) ? require('../../assets/mapIcons/resource-active-map-icon.svg') : require('../../assets/mapIcons/resource-map-icon.svg'),
        zIndex: (data.id === this.selectedMapData.id) ? 1 : 0,
        optimized: false
      }))
    },
    // param
    resoucreMapDatas () {
      return this.param.resoucreMapDatas
    }
  },
  methods: {
    // google map
    markerEvent (event, marker, map) {
      if (event === 'click') {
        const position = marker.getPosition()
        const mapData = {
          center: map.getCenter(),
          zoom: map.getZoom()
        }
        let data = this.resoucreMapDatas.find(data => (data.latitude - 0) === position.lat() && (data.longitude - 0) === position.lng())
        this.selectedMapData = data || this.selectedMapData
        map.setCenter(mapData.center)
        map.setZoom(mapData.zoom)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/resourceMap.vue